// Cart Update Event After ATC
// Trigger Free Gift Function
// Add/Remove Free Gift
// Trigger rerender sections

const freeGiftFunction = subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
  freeGiftCartUpdate();
});



function freeGiftCartUpdate() {
  const freeGift = window.freeGift.product;
  const freeGiftEnabled = window.freeGift.enabled;
  const freeGiftThreshold = window.freeGift.threshold;
  const freeGiftTwo = window.freeGiftTwo.product;
  const freeGiftTwoEnabled = window.freeGiftTwo.enabled;
  const freeGiftTwoThreshold = window.freeGiftTwo.threshold;

  if (freeGiftEnabled && freeGiftTwoThreshold) {
     fetch("/cart.js")
      .then((res) => res.json())
      .then((data) => {
      
        const cartSubtotal = data.total_price / 100;
        const isFreeGiftInCart = data.items.some((item) => item.id == freeGift);
        const isFreeGiftTwoInCart = data.items.some((item) => item.id == freeGiftTwo);

        if (cartSubtotal > freeGiftTwoThreshold){
          // If cartSubtotal is bigger than second threshold
           if (!isFreeGiftInCart && !isFreeGiftTwoInCart) {
            // If both free gifts are not in cart
            setCartStyle()
            addVariantToCart(freeGift, 1, freeGiftTwo);
             console.log('free-gift-fetch-add')
          } else if (!isFreeGiftTwoInCart) {
            // If free gift one is in cart, but free gift two is not
            setCartStyle()
            addVariantToCart(freeGiftTwo, 1);
          }
        }
        else if (cartSubtotal >= freeGiftThreshold && cartSubtotal < freeGiftTwoThreshold) { 
          // If cart subtotal is between threshold 1 and threshold 2
          if (!isFreeGiftInCart && !isFreeGiftInCart) {
            // If both free gift 1 and 2 is not in cart
            setCartStyle()
            addVariantToCart(freeGift, 1);
             console.log('free-gift-fetch-add')
          } else if (!isFreeGiftInCart && isFreeGiftTwoInCart){
            setCartStyle()
            removeVariantFromCart(freeGiftTwo)
            addVariantToCart(freeGift, 1);
             console.log('free-gift-fetch-add')
          } else if (isFreeGiftInCart && isFreeGiftTwoInCart){
                  setCartStyle()
             removeVariantFromCart(freeGiftTwo)
          }

        } else if (cartSubtotal < freeGiftThreshold ) {
          if (isFreeGiftInCart && isFreeGiftTwoInCart){
            setCartStyle()
            removeVariantFromCart(freeGift, freeGiftTwo)
          } else if (isFreeGiftInCart) {
            setCartStyle()
            removeVariantFromCart(freeGift);
          }
        }
      })
    
  } else if (freeGiftEnabled) {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((data) => {
      
        const cartSubtotal = data.total_price / 100;
        const isFreeGiftInCart = data.items.some((item) => item.id == freeGift);
        if (cartSubtotal >= freeGiftThreshold) {
       
          if (!isFreeGiftInCart) {
          setCartStyle()
            addVariantToCart(freeGift, 1);
             console.log('free-gift-fetch-add')
          }
        } else if (cartSubtotal < freeGiftThreshold) {
          if (isFreeGiftInCart) {
          setCartStyle()
            removeVariantFromCart(freeGift);
          }
        }
      });
  }

}

function setCartStyle(){
    if(document.querySelector("#CartDrawer-CartItems")){
        document.querySelector("#CartDrawer-CartItems").style.opacity = "0.5";
        document.querySelector("#CartDrawer-CartItems").style.pointerEvents = "none";
    }
  
    if(document.querySelector(".cart__items")){
        document.querySelector(".cart__items").style.opacity = "0.5";
        document.querySelector(".cart__items").style.pointerEvents = "none";
    }
}

function unsetCartStyle(){
   if(document.querySelector("#CartDrawer-CartItems")){
        document.querySelector("#CartDrawer-CartItems").style.opacity = "1";
        document.querySelector("#CartDrawer-CartItems").style.pointerEvents = "auto";
    }

    if(document.querySelector(".cart-items")){
       document.querySelector(".cart-items").style.opacity = "1";
        document.querySelector(".cart-items").style.pointerEvents = "auto";
    }
}

function addVariantToCart(variant, quantity = 1, variantTwo) {
  let sectionToUpdate = "cart-drawer,cart-icon-bubble";
  let formData = {
    items: [
      {
        id: parseFloat(variant),
        quantity,
      },
    ],
    sections: sectionToUpdate,
  }
  if (variantTwo){
  formData = {
      items: [
        {
          id: parseFloat(variant),
          quantity,
        },
        {
          id: parseFloat(variantTwo),
          quantity,
        },
      ],
      sections: sectionToUpdate,
    };
  }

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (response.status === 200) {
      return response.json();
      } else {
        console.log(response.status)
       
      }
    })
    .then((response) => {
      if (response == undefined){
        unsetCartStyle()
       
      } else {
      document.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            parsedState: response,
          },
        })
      );
    }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function removeVariantFromCart(variant, variantTwo) {
  let sectionToUpdate = "cart-drawer,cart-icon-bubble";
  let updates = {
    [variant]: 0,
  };
  
  if (variantTwo){
    updates = {
    [variant]: 0,
    [variantTwo]:0
  };
  }


  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates, sections: sectionToUpdate }),
  })
    .then((response) => {
       if (response.status === 200) {
      return response.json();
      } else {
        console.log(response.status)
       
      }
    })
    .then((response) => {
      if (response == undefined){
        unsetCartStyle()
       
      } {
      document.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            parsedState: response,
            action: "remove",
            variant: variant,
          },
        })
      );
    }
    })
    .finally(() => {
      // Set Cart To Have is empty class to show empty cart properly
      if (
        document
          .querySelector("cart-drawer")
          .querySelector(".drawer__inner-empty")
      ) {
        document.querySelector("cart-drawer").classList.add("is-empty");
      }

      setTimeout(() => {
        if (document.querySelector("cart-items")) {
          console.log("yes");
          if (
            document
              .querySelector("cart-items")
              .querySelector(".cart__warnings")
          ) {
            console.log("is-empty");
            document.querySelector("cart-items").classList.add("is-empty");
            document
              .querySelector("#main-cart-footer")
              .classList.add("is-empty");
          }
        }
      }, "300");
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
